import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';

import { IModel } from '~/src/dash/components/model';
import { IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { SnackbarView } from '~/src/dash/views/snackbar-view';
import { ButtonV2, ct, spacing } from '~/src/dash/publicaUI';

export interface IModelDialogDeleteProps extends IWithStylesProps, IModel {
  active: boolean;
  deleteModel: (modelID: string, idx?: number) => Promise<any>;
  model: string;
  idx?: number;
  onClose?: (modelID: string) => void;
  onError?: (modelID: string) => void;
  onDelete?: (modelID: string, idx?: number) => void;
  disableSnackbar?: boolean;
  customMessage?: string;
}

interface IState {
  deleting: boolean;
  snackbar: boolean;
  err: boolean;
}

export const ModelDialogDeleteView = decorate(
  {
    styles: (theme: any) => ({
      icon: {
        fontSize: '1rem',
        marginRight: '1rem',
      },
      error: {
        backgroundColor: theme.palette.error.dark,
      },
      message: {
        display: 'inline-flex',
        'align-items': 'center',
      },
    }),
  },
  class extends React.Component<IModelDialogDeleteProps, IState> {
    state = {
      deleting: false,
      snackbar: false,
      err: false,
    };

    onClose = () => {
      if (this.props.onClose) {
        this.props.onClose(this.props.ID);
      }
      this.setState({
        err: false,
      });
    };

    onError = () => {
      if (this.props.onError) {
        this.props.onError(this.props.ID);
      }
      this.setState({
        deleting: false,
        snackbar: true,
        err: true,
      });
    };

    onDelete = () => {
      if (this.props.onDelete) {
        this.props.onDelete(this.props.ID, this.props.idx);
      }
      this.setState({
        deleting: false,
        snackbar: true,
        err: false,
      });
    };

    onCloseSnackbar = () => {
      this.setState({
        snackbar: false,
      });
    };

    deleteModel = () => {
      this.setState({
        snackbar: false,
        deleting: true,
      });
      this.props.deleteModel(this.props.ID, this.props.idx).then(this.onDelete, this.onError);
    };

    componentDidUpdate(prevProps: IModelDialogDeleteProps) {
      if (prevProps.ID !== this.props.ID) {
        this.setState({
          err: false,
        });
      }
    }

    render() {
      return (
        <div>
          <Dialog
            open={this.props.active}
            onClose={this.onClose}
            disableBackdropClick={this.state.deleting}
            disableEscapeKeyDown={this.state.deleting}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <div style={{ padding: `${spacing.large} ${spacing.extraLarge}` }}>
              <DialogTitle style={{ padding: `${spacing.base} 0` }}>
                {`${ct('Delete')} ${this.props.model}: ${this.props.Name}?`}
              </DialogTitle>
              <DialogContent style={{ padding: `${spacing.small} 0` }}>
                {this.props.customMessage && (
                  <DialogContentText>{this.props.customMessage}</DialogContentText>
                )}
                <DialogContentText id='alert-dialog-description'>
                  {ct('ModalShouldItemBeRemoved', { item: this.props.Name })}
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ padding: `${spacing.small} 0` }}>
                <Button
                  onClick={this.onClose}
                  color='primary'
                  autoFocus
                  disabled={this.state.deleting}
                >
                  {ct('Cancel')}
                </Button>

                <ButtonV2
                  onClick={this.deleteModel}
                  disabled={this.state.deleting}
                  style={{ marginLeft: spacing.base }}
                >
                  {ct('ModalYesDeleteItem', { item: this.props.model })}
                  {this.state.deleting && (
                    <span style={{ marginLeft: spacing.small }}>
                      <CircularProgress size={12} />
                    </span>
                  )}
                </ButtonV2>
              </DialogActions>
            </div>
          </Dialog>

          {!this.props.disableSnackbar && (
            <SnackbarView
              open={this.state.snackbar}
              error={this.state.err}
              onClose={this.onCloseSnackbar}
            >
              {this.state.err
                ? ct('ModalFailedToDeleteItemIDName', {
                    item: this.props.model,
                    id: this.props.ID,
                    name: this.props.Name,
                  })
                : ct('ModalDeletedItemIDName', {
                    item: this.props.model,
                    id: this.props.ID,
                    name: this.props.Name,
                  })}
            </SnackbarView>
          )}
        </div>
      );
    }
  },
);
